import { XIcon } from "lucide-react"
import { toast as sonnerToast } from "sonner"

interface ToastProps {
  id: string | number
  label: string
}

/** I recommend abstracting the toast function
 *  so that you can call it without having to use toast.custom everytime. */
export const makeErrorToast = (toast: Omit<ToastProps, "id">) => {
  return sonnerToast.custom((id) => <Toast id={id} label={toast.label} />)
}

/** A fully custom toast that still maintains the animations and interactions. */
const Toast = (props: ToastProps) => {
  const { label, id } = props

  return (
    <div className="flex w-full items-center justify-between rounded-lg bg-warning-100 p-4">
      <div className="w-6" />
      <p className="text-base/[120%] font-semibold text-white">{label}</p>
      <button
        className="flex size-6 items-center justify-center"
        onClick={() => {
          sonnerToast.dismiss(id)
        }}
      >
        <XIcon className="size-5 text-white" />
      </button>
    </div>
  )
}
